<script lang="ts">
  import Editor from "$lib/components/Editor.svelte";
  import type { EditorContent } from "$lib/types/editor-content";

  const { data } = $props();
  const alert = data.alert;

  let visible = $state(alert.visible);
  let content = $state<EditorContent>(alert.content || { time: Date.now(), blocks: [] });

    async function submit(event: Event) {
        event.preventDefault();

        const res = await fetch('/admin', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ visible, content })
        });

        if (res.ok) {
            window.alert('Zapisano zmiany');
        } else {
            window.alert('Wystąpił błąd podczas zapisywania zmian');
        }
    }
</script>

<h1 class="heading">Komunikat</h1>

<form onsubmit={submit} class="form-group">
    <div>
        <label>
            Komunikat widoczny
            <input type="checkbox" bind:checked={visible} />
        </label>
    </div>

    <div>
        <Editor bind:value={content} />
    </div>

    <div>
        <button type="submit" class="btn">Zapisz</button>
    </div>
</form>